import { render, staticRenderFns } from "./LoginSimplified.vue?vue&type=template&id=a9950a6c&scoped=true&"
import script from "./LoginSimplified.vue?vue&type=script&lang=js&"
export * from "./LoginSimplified.vue?vue&type=script&lang=js&"
import style0 from "./LoginSimplified.vue?vue&type=style&index=0&id=a9950a6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9950a6c",
  null
  
)

export default component.exports